
(function(){
  if (window.__YSNFunnelReady) return;
  window.__YSNFunnelReady = true;

  function qs(sel, root){return (root||document).querySelector(sel)}
  function qsa(sel, root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function moneyText(t){return (t||'').trim();}
  function aggregate(items, useSellingPlans){
    var map={};
    (items||[]).forEach(function(it){
      var id=parseInt(it.id,10), q=parseInt(it.quantity,10)||0;
      if(!id||q<=0) return;
      var sp = useSellingPlans && it.selling_plan ? String(it.selling_plan).trim() : '';
      var key = id + '::' + sp;
      if(!map[key]) map[key] = {id:id, quantity:0};
      map[key].quantity += q;
      if(sp) map[key].selling_plan = sp;
    });
    return Object.keys(map).map(function(k){return map[k];});
  }
  function itemRole(it){
    return String((it && (it._ysn_role || it.role)) || '').toLowerCase();
  }
  function splitBundleItems(items){
    var paid=[], gifts=[];
    (items||[]).forEach(function(it){
      if(!it || !it.id) return;
      if(itemRole(it)==='gift') gifts.push(it);
      else paid.push(it);
    });
    return {paid:paid, gifts:gifts};
  }
  function addBundleItems(giftItems, paidItems, payloadSections){
    // Performance path: add the complete bundle in one Shopify request.
    // Keeping gifts before paid items preserves the previous visual ordering in
    // Horizon carts, while eliminating the old second sequential /cart/add call.
    var items = (giftItems || []).concat(paidItems || []);
    var body = {items:items};
    if(payloadSections){
      body.sections = payloadSections;
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js',{
      method:'POST',
      priority:'high',
      credentials:'same-origin',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json',
        'X-Requested-With':'XMLHttpRequest'
      },
      body:JSON.stringify(body)
    }).then(function(r){if(!r.ok) throw r; return r.json();});
  }
  function selectedCard(scope){return qs('[data-nx-offer-card].is-selected', scope) || qs('[data-nx-offer-card]', scope);}
  function findExternalSellingPlan(scope){
    var root = scope ? (scope.closest('product-information') || scope.closest('.shopify-section') || document) : document;
    var selectors = [
      'input[name="selling_plan"]:checked',
      'input[name="selling_plan"][type="hidden"]',
      'select[name="selling_plan"]',
      '[data-selling-plan-id].is-selected',
      '[data-selling-plan-id][aria-checked="true"]',
      '[data-selling-plan-id][data-selected="true"]',
      '[data-selling-plan-id][data-checked="true"]',
      '[data-selling-plan-id][checked]'
    ];
    for(var i=0;i<selectors.length;i++){
      var el = qs(selectors[i], root) || qs(selectors[i], document);
      if(el){
        var val = el.value || el.getAttribute('data-selling-plan-id') || el.getAttribute('data-value') || el.getAttribute('value');
        if(val && String(val).trim() && String(val).trim() !== 'null' && String(val).trim() !== 'on') return String(val).trim();
      }
    }
    return '';
  }
  function findExternalSubWidget(scope){
    if(!scope) return null;
    var selector = scope.getAttribute('data-external-app-selector') || '.sls-purchase-options-container, [class*=\"sls-purchase\"], .seal-subscription-widget, .seal-purchase-options, [class*=\"seal-subscription\"], [data-seal-subscriptions], .appstle_subscription_widget, [data-selling-plans], [data-seal-subscription], .recharge-subscription-widget, .skio-plan-picker';
    var root = scope.closest('product-information') || scope.closest('.shopify-section') || document;
    var candidates = [];
    if(selector){
      try { candidates = candidates.concat(qsa(selector, root)); } catch(e) {}
      try { candidates = candidates.concat(qsa(selector, document)); } catch(e) {}
    }
    candidates = candidates.filter(function(el){ return el && el !== scope && !scope.contains(el); });
    return candidates[0] || null;
  }
  function safeExternalWidgetWrapper(widget, scope){
    if(!widget || !scope) return widget;
    var root = scope.closest('product-information') || scope.closest('.shopify-section') || document;
    var wrapper = widget.closest('.shopify-block, .shopify-app-block, [data-block-id], [id^="shopify-block-"]') || widget;
    var unsafe = ['product-information','.product-information','.product-details','.shopify-section','main','body','html'];
    for(var i=0;i<unsafe.length;i++){
      try{ if(wrapper.matches && wrapper.matches(unsafe[i])) return widget; }catch(e){}
    }
    if(scope.contains(wrapper) || wrapper.contains(scope)) return widget;
    if(root && root !== document && !root.contains(wrapper)) return widget;
    return wrapper;
  }
  function visuallyHideExternalSubWidget(scope){
    if(!scope || scope.getAttribute('data-hide-external-app') !== 'true') return;
    var selector = scope.getAttribute('data-external-app-selector') || '.sls-purchase-options-container, [class*=\"sls-purchase\"], .seal-subscription-widget, .seal-purchase-options, [class*=\"seal-subscription\"], [data-seal-subscriptions], .appstle_subscription_widget, [data-selling-plans], [data-seal-subscription], .recharge-subscription-widget, .skio-plan-picker';
    var root = scope.closest('product-information') || scope.closest('.shopify-section') || document;
    var widgets = [];
    try{ widgets = widgets.concat(qsa(selector, root)); }catch(e){}
    try{ widgets = widgets.concat(qsa(selector, document)); }catch(e){}
    widgets.forEach(function(widget){
      if(!widget || widget === scope || scope.contains(widget)) return;
      var wrapper = safeExternalWidgetWrapper(widget, scope);
      widget.setAttribute('data-ysn-hidden-subscription-app','true');
      widget.classList.add('ysn-visually-hidden-subscription-app');
      if(wrapper && wrapper !== widget){
        wrapper.classList.add('ysn-hidden-subscription-wrapper');
        wrapper.setAttribute('data-ysn-hidden-subscription-wrapper','true');
      }
      try{
        [widget, wrapper].forEach(function(el){
          if(!el) return;
          el.style.removeProperty('display');
          el.style.removeProperty('visibility');
          el.style.removeProperty('opacity');
        });
      }catch(e){}
      try{ widget.setAttribute('aria-hidden','true'); }catch(e){}
    });
  }
  function syncExternalSubscriptionChoice(scope, plan){
    var widget = findExternalSubWidget(scope);
    if(!widget) return;
    var wanted = plan === 'subscription' ? ['subscribe','subscription','recurring','selling','abonnement','hebdo','weekly','renewal','renouvellement'] : ['one','onetime','one-time','standard','unique','achat unique'];
    var radios = qsa('input[type="radio"]', widget);
    for(var i=0;i<radios.length;i++){
      var text = ((radios[i].value||'') + ' ' + (radios[i].id||'') + ' ' + (radios[i].name||'') + ' ' + (radios[i].closest('label') ? radios[i].closest('label').textContent : '')).toLowerCase();
      if(wanted.some(function(w){return text.indexOf(w) !== -1;})){
        try{ radios[i].click(); radios[i].checked = true; radios[i].dispatchEvent(new Event('input',{bubbles:true})); radios[i].dispatchEvent(new Event('change',{bubbles:true})); }catch(e){}
        break;
      }
    }
  }
  function initExternalSubBridge(scope){
    if(!scope) return;
    visuallyHideExternalSubWidget(scope);
    if(scope.__ysnBridgeInit) return;
    scope.__ysnBridgeInit = true;
    var root = scope.closest('product-information') || scope.closest('.shopify-section') || document.body;
    // V55: subscription apps often render after the theme block. Keep re-applying the safe visual hide,
    // without display:none and without touching Product information itself.
    if(root && 'MutationObserver' in window){
      var mo = new MutationObserver(function(){ visuallyHideExternalSubWidget(scope); });
      try{ mo.observe(root,{childList:true,subtree:true}); }catch(e){}
    }
    setTimeout(function(){ visuallyHideExternalSubWidget(scope); }, 250);
    setTimeout(function(){ visuallyHideExternalSubWidget(scope); }, 900);
    setTimeout(function(){ visuallyHideExternalSubWidget(scope); }, 1800);
  }
  function updateGifts(scope, cardOrLevel){
    var level = typeof cardOrLevel === 'number' ? cardOrLevel : parseInt(cardOrLevel && cardOrLevel.getAttribute('data-level'),10) || 1;
    var giftProducts = [];
    var virtualGiftCount = null;
    if(cardOrLevel && typeof cardOrLevel !== 'number'){
      giftProducts = (cardOrLevel.getAttribute('data-gift-products') || '').split(',').map(function(x){return String(x||'').trim();}).filter(Boolean);
      var rawVirtualCount = cardOrLevel.getAttribute('data-virtual-gift-count');
      if(rawVirtualCount !== null && rawVirtualCount !== ''){
        virtualGiftCount = Math.max(0, parseInt(rawVirtualCount, 10) || 0);
      }
    }
    var useExactGiftProducts = giftProducts.length > 0;
    var giftNodes = qsa('[data-nx-gift-min]', scope);
    var virtualSeen = 0;
    giftNodes.forEach(function(g){
      var locked;
      var isVirtual = g.getAttribute('data-nx-virtual-gift') === 'true';
      if(virtualGiftCount !== null && isVirtual){
        // Count only virtual gifts here. Do not use the DOM index because
        // the panel is re-sorted after each selection to place unlocked gifts first.
        // Using the global index made virtual gifts lock/unlock incorrectly after
        // switching between offers that mix virtual and physical gifts.
        virtualSeen += 1;
        locked = virtualSeen > virtualGiftCount;
      } else if(useExactGiftProducts && !isVirtual){
        var gid = String(g.getAttribute('data-nx-gift-product-id') || '').trim();
        locked = !gid || giftProducts.indexOf(gid) === -1;
      } else {
        var min=parseInt(g.getAttribute('data-nx-gift-min'),10)||1;
        locked=min>level;
      }
      g.classList.toggle('is-locked', locked);
      g.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });

    // Keep unlocked gifts visually first, even when the panel mixes virtual and product gifts.
    // This avoids a locked virtual row appearing between two unlocked gifts.
    var giftPanel = qs('.nx-gifts-panel', scope);
    if(giftPanel){
      var items = qsa('[data-nx-gift-min]', giftPanel);
      items.forEach(function(item, order){ if(!item.hasAttribute('data-nx-original-order')) item.setAttribute('data-nx-original-order', String(order)); });
      items.sort(function(a,b){
        var al = a.classList.contains('is-locked') ? 1 : 0;
        var bl = b.classList.contains('is-locked') ? 1 : 0;
        if(al !== bl) return al - bl;
        var amin = parseInt(a.getAttribute('data-nx-gift-min'),10) || 999;
        var bmin = parseInt(b.getAttribute('data-nx-gift-min'),10) || 999;
        if(amin !== bmin) return amin - bmin;
        return (parseInt(a.getAttribute('data-nx-original-order'),10)||0) - (parseInt(b.getAttribute('data-nx-original-order'),10)||0);
      });
      var noteNode = qs('[data-nx-gift-note]', giftPanel);
      items.forEach(function(item){ giftPanel.insertBefore(item, noteNode || null); });
    }

    var unlockedItems = qsa('[data-nx-gift-min]:not(.is-locked)', scope);
    var allItems = qsa('[data-nx-gift-min]', scope);
    var badge=qs('[data-nx-unlocked-count]', scope);
    if(badge){
      var label = badge.getAttribute('data-unlocked-label') || 'unlocked';
      badge.textContent=unlockedItems.length+' '+label;
    }
    var note = qs('[data-nx-gift-note]', scope);
    if(note){
      var behavior = note.getAttribute('data-complete-behavior') || 'success';
      var isComplete = allItems.length > 0 && unlockedItems.length >= allItems.length;
      note.classList.toggle('is-complete', isComplete && behavior === 'success');
      note.classList.toggle('is-hidden', isComplete && behavior === 'hide');
      if(isComplete && behavior === 'success'){
        note.textContent = note.getAttribute('data-complete-note') || 'You have unlocked the maximum gift offer available with this bundle.';
      }else{
        note.textContent = note.getAttribute('data-default-note') || note.textContent;
      }
    }
  }
  function hexToRgb(hex){
    hex = String(hex || '').trim().replace('#','');
    if(hex.length === 3) hex = hex.split('').map(function(c){return c+c;}).join('');
    var n = parseInt(hex,16);
    if(isNaN(n)) return {r:22,g:134,b:90};
    return {r:(n>>16)&255,g:(n>>8)&255,b:n&255};
  }
  function mixRgb(a,b,t){
    return {r:Math.round(a.r+(b.r-a.r)*t),g:Math.round(a.g+(b.g-a.g)*t),b:Math.round(a.b+(b.b-a.b)*t)};
  }
  function rgbCss(c){return 'rgb('+c.r+','+c.g+','+c.b+')';}
  function getCssVar(el,name,fallback){
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    return v || fallback;
  }
  function progressColor(scope, pct){
    var low = hexToRgb(getCssVar(scope,'--nx-progress-low','#c83f3f'));
    var mid = hexToRgb(getCssVar(scope,'--nx-progress-mid','#d4a83f'));
    var high = hexToRgb(getCssVar(scope,'--nx-progress-high','#16865a'));
    pct = Math.max(0, Math.min(100, pct));
    if(pct < 50) return rgbCss(mixRgb(low, mid, pct/50));
    return rgbCss(mixRgb(mid, high, (pct-50)/50));
  }
  function updateProgressBars(scope){
    qsa('.nx-save-bar', scope).forEach(function(bar){
      var raw = getComputedStyle(bar).getPropertyValue('--save') || bar.style.getPropertyValue('--save') || '0';
      var pct = parseFloat(String(raw).replace('%',''));
      if(isNaN(pct)) pct = 0;
      pct = Math.max(0, Math.min(100, pct));
      bar.style.setProperty('--save', pct + '%');
      if(bar.getAttribute('data-nx-dynamic-progress') === 'true'){
        bar.style.setProperty('--nx-progress-fill', progressColor(scope, pct));
      }
    });
  }
  function updateOffer(scope){
    var card=selectedCard(scope); if(!card) return;
    qsa('[data-nx-offer-card]', scope).forEach(function(c){
      var on=c===card;
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-checked', on?'true':'false');
    });
    var plan = 'onetime';
    var planBox = qs('[data-nx-subscription-box]', scope);
    if(planBox){
      var refill = qs('input[type="checkbox"][data-nx-plan-toggle][value="subscription"]', planBox);
      if(refill){ plan = refill.checked ? 'subscription' : 'onetime'; }
      else { var checkedPlan = qs('[data-nx-plan-toggle]:checked', planBox); if(checkedPlan) plan = checkedPlan.value; }
    }
    else if(scope.getAttribute('data-default-plan') === 'subscription') plan = 'subscription';
    syncExternalSubscriptionChoice(scope, plan);
    qsa('[data-nx-offer-card]', scope).forEach(function(offerCard){
      var cardPrice = qs('.nx-price', offerCard);
      if(cardPrice){
        var cardPriceText = plan === 'subscription' ? (offerCard.getAttribute('data-sub-price') || offerCard.getAttribute('data-price')) : (offerCard.getAttribute('data-one-price') || offerCard.getAttribute('data-price'));
        cardPrice.textContent = moneyText(cardPriceText);
      }
    });
    var price=qs('[data-nx-offer-price]', scope);
    var priceText = plan === 'subscription' ? (card.getAttribute('data-sub-price') || card.getAttribute('data-price')) : (card.getAttribute('data-one-price') || card.getAttribute('data-price'));
    if(price) price.textContent=moneyText(priceText);
    var subPrice=qs('[data-nx-sub-price-label]', scope); if(subPrice) subPrice.textContent=moneyText(card.getAttribute('data-sub-price') || subPrice.textContent);
    var onePrice=qs('[data-nx-one-price-label]', scope); if(onePrice) onePrice.textContent=moneyText(card.getAttribute('data-one-price') || onePrice.textContent);
    updateGifts(scope, card);
    updateProgressBars(scope);
  }
  function visibleIndex(row){
    var children=qsa(':scope > *', row).filter(function(el){return el.offsetWidth>0});
    if(!children.length) return 0;
    var center=row.scrollLeft + row.clientWidth/2;
    var idx=0, best=1e9;
    children.forEach(function(el,i){var c=el.offsetLeft + el.offsetWidth/2; var d=Math.abs(c-center); if(d<best){best=d; idx=i;}});
    return idx;
  }
  function updateDots(row){
    var wrap=row.closest('[data-ysn-carousel]') || row.parentElement; if(!wrap) return;
    var dots=qsa('[data-ysn-dot]', wrap); if(!dots.length) return;
    var idx=visibleIndex(row);
    dots.forEach(function(d,i){d.classList.toggle('is-active', i===idx); d.setAttribute('aria-current', i===idx ? 'true' : 'false');});
  }
  function initCarousels(root){
    qsa('[data-nx-scroll-row], [data-ysn-scroll-row]', root||document).forEach(function(row){
      if(row.__ysnCarousel) { updateDots(row); return; }
      row.__ysnCarousel=true;
      var raf=null;
      row.addEventListener('scroll', function(){
        if(raf) cancelAnimationFrame(raf);
        raf=requestAnimationFrame(function(){updateDots(row);});
      }, {passive:true});
      var wrap=row.closest('[data-ysn-carousel]')||row.parentElement;
      if(wrap){
        qsa('[data-ysn-dot]', wrap).forEach(function(dot,i){
          dot.addEventListener('click', function(){
            var children=qsa(':scope > *', row).filter(function(el){return el.offsetWidth>0});
            var child=children[i];
            if(child) row.scrollTo({left:child.offsetLeft - parseFloat(getComputedStyle(row).scrollPaddingLeft||0), behavior:'smooth'});
          });
        });
      }
      updateDots(row);
    });
  }
  function setVideoState(card, playing){
    if(!card) return;
    card.classList.toggle('is-playing', !!playing);
    card.classList.toggle('is-paused', !playing);
  }
  function toggleVideo(shell){
    if(!shell) return;
    var card=shell.closest('.nx-video-card') || shell.closest('[data-ysn-video-card]');
    var v=qs('video', shell);
    if(!v) return;
    if(!v.getAttribute('src') && !v.querySelector('source')) { try{ v.controls=true; }catch(e){} return; }
    if(v.paused || v.ended){
      qsa('.nx-video-shell video').forEach(function(o){ if(o!==v){ try{o.pause();}catch(e){} setVideoState(o.closest('.nx-video-card')||o.closest('[data-ysn-video-card]'), false); }});
      try{ v.muted=false; v.playsInline=true; v.removeAttribute('controls'); }catch(e){}
      var playPromise;
      try { playPromise=v.play(); } catch(err) { playPromise=Promise.reject(err); }
      if(playPromise && playPromise.then){
        playPromise.then(function(){ setVideoState(card,true); }).catch(function(){
          try { v.muted=true; playPromise=v.play(); } catch(e2) {}
          if(playPromise && playPromise.then){
            playPromise.then(function(){ setVideoState(card,true); }).catch(function(){ v.controls=true; setVideoState(card,false); });
          } else { v.controls=true; setVideoState(card,false); }
        });
      } else { setVideoState(card,true); }
    }else{
      try{ v.pause(); }catch(e){}
      setVideoState(card,false);
    }
  }
  function initTimers(root){
    qsa('[data-nx-countdown]', root||document).forEach(function(el){
      if(el.__ysnTimer) return; el.__ysnTimer=true;
      var mode=el.getAttribute('data-mode') || 'daily_deadline';
      var hour=parseInt(el.getAttribute('data-hour'),10); if(isNaN(hour)) hour=23;
      var minute=parseInt(el.getAttribute('data-minute'),10); if(isNaN(minute)) minute=59;
      var durationHours=parseInt(el.getAttribute('data-duration-hours'),10); if(isNaN(durationHours)) durationHours=0;
      var durationMinutes=parseInt(el.getAttribute('data-duration-minutes'),10); if(isNaN(durationMinutes)) durationMinutes=15;
      var durationMs=Math.max(60 * 1000, ((durationHours * 60) + durationMinutes) * 60 * 1000);
      var durationEnd=null;
      if(mode === 'duration') durationEnd = new Date(Date.now() + durationMs);
      function tick(){
        var now=new Date();
        var end;
        if(mode === 'duration'){
          end = durationEnd || new Date(now.getTime() + durationMs);
        } else {
          end=new Date(now); end.setHours(hour,minute,59,999); if(end<=now) end.setDate(end.getDate()+1);
        }
        var diff=Math.max(0,end-now); var h=Math.floor(diff/36e5), m=Math.floor(diff%36e5/6e4), s=Math.floor(diff%6e4/1000);
        var hs=qs('[data-h]',el), ms=qs('[data-m]',el), ss=qs('[data-s]',el);
        if(hs) hs.textContent=String(h).padStart(2,'0'); if(ms) ms.textContent=String(m).padStart(2,'0'); if(ss) ss.textContent=String(s).padStart(2,'0');
      }
      tick(); setInterval(tick,1000);
    });
    qsa('[data-nx-date-plus]', root||document).forEach(function(el){
      var d=new Date();
      d.setDate(d.getDate()+(parseInt(el.getAttribute('data-nx-date-plus'),10)||0));
      var locale=el.getAttribute('data-locale')||'en-US';
      var format=el.getAttribute('data-date-format')||'month_day';
      var months=(el.getAttribute('data-months')||'').split('|').map(function(x){return x.trim();});
      var shortMonths=(el.getAttribute('data-short-months')||'').split('|').map(function(x){return x.trim();});
      var day=String(d.getDate()); var dd=day.padStart(2,'0'); var monthIndex=d.getMonth(); var mm=String(monthIndex+1).padStart(2,'0'); var year=String(d.getFullYear());
      var monthName = months[monthIndex] || d.toLocaleDateString(locale,{month:'long'});
      var shortMonthName = shortMonths[monthIndex] || d.toLocaleDateString(locale,{month:'short'});
      if(format==='day_month_year') el.textContent=day+' '+monthName+' '+year;
      else if(format==='day_month') el.textContent=day+' '+monthName;
      else if(format==='month_day_year') el.textContent=monthName+' '+day+', '+year;
      else if(format==='numeric_dmy') el.textContent=dd+'/'+mm+'/'+year;
      else if(format==='numeric_mdy') el.textContent=mm+'/'+dd+'/'+year;
      else el.textContent=shortMonthName+' '+day;
    });
    qsa('[data-nx-date-text]', root||document).forEach(function(el){
      var tpl=el.getAttribute('data-template')||'Order by [today]';
      var d=new Date();
      var locale=el.getAttribute('data-locale')||'en-US';
      var format=el.getAttribute('data-date-format')||'month_day_year';
      var months=(el.getAttribute('data-months')||'').split('|').map(function(x){return x.trim();});
      var shortMonths=(el.getAttribute('data-short-months')||'').split('|').map(function(x){return x.trim();});
      var day=String(d.getDate()); var dd=day.padStart(2,'0'); var monthIndex=d.getMonth(); var mm=String(monthIndex+1).padStart(2,'0'); var year=String(d.getFullYear());
      var monthName = months[monthIndex] || d.toLocaleDateString(locale,{month:'long'});
      var shortMonthName = shortMonths[monthIndex] || d.toLocaleDateString(locale,{month:'short'});
      var date;
      if(format==='day_month_year') date=day+' '+monthName+' '+year;
      else if(format==='day_month') date=day+' '+monthName;
      else if(format==='month_day') date=monthName+' '+day;
      else if(format==='numeric_dmy') date=dd+'/'+mm+'/'+year;
      else if(format==='numeric_mdy') date=mm+'/'+dd+'/'+year;
      else date=monthName+' '+day+', '+year;
      el.textContent=tpl.replace(/\[today\]/g,date).replace(/\[day\]/g,day).replace(/\[dd\]/g,dd).replace(/\[month\]/g,monthName).replace(/\[month_short\]/g,shortMonthName).replace(/\[mm\]/g,mm).replace(/\[year\]/g,year);
    });
  }
  function initReveal(root){
    var els=qsa('.nx-section .nx-card,.nx-section .nx-title,.nx-section .nx-subtitle,.nx-animate', root||document);
    if(!('IntersectionObserver' in window)){els.forEach(function(el){el.classList.add('is-in-view')}); return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in-view');io.unobserve(en.target);}})},{threshold:.12});
    els.forEach(function(el){ if(!el.__ysnReveal){el.__ysnReveal=true; el.classList.add('nx-animate'); io.observe(el);} });
  }


  function getYsnProductInformationSection(fromEl){
    if(fromEl && fromEl.closest){
      var closestSection = fromEl.closest('.product-information, [data-testid="product-information"]');
      if(closestSection) return closestSection;
    }

    return qs('.product-information[data-testid="product-information"]') ||
      qs('[data-testid="product-information"].product-information') ||
      qs('.product-information') ||
      qs('[data-testid="product-information"]');
  }

  function resolveYsnScrollTarget(selector){
    selector = (selector || '').trim();

    var productInfoFallback = function(){
      /* For Product Information links, always scroll to the top of the whole
         product section, including the media/gallery column. The native
         ProductInformation-* id is inside the details column, so using it
         directly lands in the middle of the section on product pages. */
      var details = qs('[id^="ProductInformation-"]') ||
        qs('[data-testid="product-information-details"]') ||
        qs('.product-information .product-details');

      return getYsnProductInformationSection(details) || details;
    };

    var isProductInfoSelector = !selector ||
      selector === '#ProductInformation-' ||
      selector === '#product-information' ||
      selector === '#product-information-main' ||
      selector.indexOf('#ProductInformation-') === 0;

    if(isProductInfoSelector){
      return productInfoFallback();
    }

    try{
      var found = qs(selector);
      if(found){
        if(found.id && found.id.indexOf('ProductInformation-') === 0){
          return getYsnProductInformationSection(found) || found;
        }
        return found;
      }
      return productInfoFallback();
    }catch(e){
      return productInfoFallback();
    }
  }


  function getYsnScrollOffset(){
    var doc = document.documentElement;
    var cssHeader = parseFloat(getComputedStyle(doc).getPropertyValue('--header-height')) || 0;
    var header = qs('sticky-header, header.shopify-section, .shopify-section-group-header-group, .header, [data-header]');
    var headerH = 0;
    if(header && header.getBoundingClientRect){
      var r = header.getBoundingClientRect();
      var pos = getComputedStyle(header).position;
      if(pos === 'fixed' || pos === 'sticky') headerH = Math.max(0, r.height || 0);
    }
    return Math.max(cssHeader, headerH) + 12;
  }

  function scrollYsnTargetToStart(el){
    if(!el || !el.getBoundingClientRect) return;
    var y = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - getYsnScrollOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function isElementVisibleInViewport(el, buffer){
    if(!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var vw = window.innerWidth || document.documentElement.clientWidth || 0;
    buffer = parseInt(buffer,10) || 0;
    return r.bottom > buffer && r.top < (vh - buffer) && r.right > 0 && r.left < vw;
  }
  function updateStickyCtas(){
    var doc = document.documentElement;
    var scrollTop = window.pageYOffset || doc.scrollTop || document.body.scrollTop || 0;
    var maxScroll = Math.max(1, (doc.scrollHeight || document.body.scrollHeight || 1) - (window.innerHeight || doc.clientHeight || 1));
    var pct = Math.max(0, Math.min(100, (scrollTop / maxScroll) * 100));
    qsa('[data-ysn-sticky-cta]').forEach(function(el){
      var showAfter = parseFloat(el.getAttribute('data-show-after') || '0');
      var hideAfter = parseFloat(el.getAttribute('data-hide-after') || '100');
      var startVisible = el.getAttribute('data-start-visible') === 'true';
      var visible = startVisible || pct >= showAfter;
      if(pct >= hideAfter) visible = false;
      if(el.getAttribute('data-hide-target') === 'true'){
        var targetSel = el.getAttribute('data-target') || '';
        var target = resolveYsnScrollTarget(targetSel);
        if(target && isElementVisibleInViewport(target, 20)) visible = false;
      }
      if(el.getAttribute('data-hide-footer') === 'true'){
        var footer = qs('footer, .footer, [id*="footer" i], [class*="footer" i]');
        if(footer && isElementVisibleInViewport(footer, 0)) visible = false;
      }
      el.classList.toggle('is-visible', !!visible);
    });
  }
  function initStickyCtas(root){
    var els = qsa('[data-ysn-sticky-cta]', root||document);
    if(!els.length) return;
    if(!window.__YSNStickyCtaEvents){
      window.__YSNStickyCtaEvents = true;
      var ticking = false;
      var requestUpdate = function(){
        if(ticking) return;
        ticking = true;
        requestAnimationFrame(function(){ ticking = false; updateStickyCtas(); });
      };
      window.addEventListener('scroll', requestUpdate, {passive:true});
      window.addEventListener('resize', requestUpdate, {passive:true});
      document.addEventListener('shopify:section:load', requestUpdate);
    }
    setTimeout(updateStickyCtas, 50);
  }

  function resetYsn17BundlePlanToDefault(scope){
    if(!scope || scope.getAttribute('data-ysn17-link-bundle') !== 'true') return;
    var def = scope.getAttribute('data-default-plan') === 'subscription' ? 'subscription' : 'onetime';
    var box = qs('[data-nx-subscription-box]', scope);
    if(!box) return;
    var refill = qs('input[type="checkbox"][data-nx-plan-toggle][value="subscription"]', box);
    if(refill){ refill.checked = (def === 'subscription'); }
    qsa('input[type="radio"][data-nx-plan-toggle]', box).forEach(function(input){ input.checked = (input.value === def); });
    qsa('.nx-subscription-option, .nx-refill-toggle', box).forEach(function(l){ l.classList.toggle('is-selected', !!qs('input:checked', l)); });
    updateOffer(scope);
  }

  function init(root){
    qsa('[data-nx-offer-scope]', root||document).forEach(function(scope){ initExternalSubBridge(scope); updateOffer(scope); });
    qsa('[data-nx-subscription-box]', root||document).forEach(function(box){
      if(box.__ysnSubInit) return; box.__ysnSubInit = true;
      qsa('[data-nx-plan-toggle]', box).forEach(function(input){
        input.addEventListener('change', function(){
          qsa('.nx-subscription-option, .nx-refill-toggle', box).forEach(function(l){ l.classList.toggle('is-selected', !!qs('input:checked', l)); });
          var scope = box.closest('[data-nx-offer-scope]'); if(scope) updateOffer(scope);
        });
      });
    });
    initTimers(root); initCarousels(root); initReveal(root); initStickyCtas(root);
  }

  document.addEventListener('click', function(e){
    var offer=e.target.closest('[data-nx-offer-card]');
    if(offer){
      var scope=offer.closest('[data-nx-offer-scope]');
      if(scope){qsa('[data-nx-offer-card]', scope).forEach(function(c){c.classList.remove('is-selected')}); offer.classList.add('is-selected'); updateOffer(scope);}
    }
    var btn=e.target.closest('[data-nx-atc]');
    if(btn){
      var scope=btn.closest('[data-nx-offer-scope]'); if(!scope) return;
      var c=selectedCard(scope); if(!c) return;
      var items=[];
      var rawItems=c.getAttribute('data-items');
      if(rawItems){
        try{ items=JSON.parse(rawItems); }catch(err){ items=[]; }
      }
      if(!items.length){
        for(var i=1;i<=30;i++){items.push({id:c.getAttribute('data-v'+i), quantity:c.getAttribute('data-q'+i)});}
      }
      var planBox=qs('[data-nx-subscription-box]', scope);
      var mode = scope.getAttribute('data-selling-plan-mode') || 'internal';
      var useSellingPlans = false;
      var externalSellingPlan = '';
      function chosenPlanValue(){
        if(!planBox) return scope.getAttribute('data-default-plan') === 'subscription' ? 'subscription' : 'onetime';
        var refill = qs('input[type="checkbox"][data-nx-plan-toggle][value="subscription"]', planBox);
        if(refill) return refill.checked ? 'subscription' : 'onetime';
        var checkedAny = qs('[data-nx-plan-toggle]:checked', planBox);
        return checkedAny ? checkedAny.value : 'onetime';
      }
      var chosenPlan = chosenPlanValue();
      if(mode === 'off') { useSellingPlans = false; }
      else if(mode === 'external') { useSellingPlans = chosenPlan === 'subscription'; externalSellingPlan = useSellingPlans ? findExternalSellingPlan(scope) : ''; useSellingPlans = useSellingPlans && !!externalSellingPlan; }
      else if(planBox){ useSellingPlans = chosenPlan === 'subscription'; }
      else { useSellingPlans = (scope.getAttribute('data-default-plan') === 'subscription'); }
      var wantsSubscription = chosenPlan === 'subscription';
      if(wantsSubscription && !externalSellingPlan){
        var hasPlanAlready = items.some(function(it){ return it && it.selling_plan; });
        if(!hasPlanAlready){ externalSellingPlan = findExternalSellingPlan(scope); }
      }
      if(externalSellingPlan){ items = items.map(function(it){ if(it && it.id && itemRole(it)!=='gift' && !it.selling_plan) it.selling_plan = externalSellingPlan; return it; }); useSellingPlans = true; }
      var linkMode = scope.getAttribute('data-link-mode') || 'shopify';
      var actionAttr = chosenPlan === 'subscription' ? (c.getAttribute('data-action-sub') || 'default') : (c.getAttribute('data-action-one') || 'default');
      var action = actionAttr === 'default' ? linkMode : actionAttr;
      var dest = chosenPlan === 'subscription' ? (c.getAttribute('data-url-sub') || '') : (c.getAttribute('data-url-one') || '');
      if((action === 'link' || linkMode === 'link') && dest){
        btn.disabled=true;
        btn.innerHTML='Redirecting...';
        window.location.href = dest;
        return;
      }
      var split = splitBundleItems(items);
      var giftItems = aggregate(split.gifts, false);
      var paidItems = aggregate(split.paid, useSellingPlans);
      items = paidItems.concat(giftItems);
      if(!items.length){alert('Configure the products/gifts for this offer in the Theme Editor.'); return;}
      btn.disabled=true; var old=btn.innerHTML; btn.innerHTML='Adding...';
      var cartSectionIds = qsa('cart-items-component[data-section-id]').map(function(el){return el.getAttribute('data-section-id');}).filter(Boolean);
      var sectionString = cartSectionIds.length ? cartSectionIds.join(',') : '';
      addBundleItems(giftItems, paidItems, sectionString)
      .then(function(data){
        var red=scope.getAttribute('data-redirect')||'checkout';
        // Redirect modes remain direct and do not wait for any secondary cart request.
        if(red==='checkout') { btn.innerHTML='Redirecting...'; window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'checkout'; return; }
        if(red==='cart') { btn.innerHTML='Opening cart...'; window.location.assign('/cart'); return; }

        var sections = data.sections || {};

        // Apply the server-rendered drawer HTML immediately, before requesting the
        // full cart JSON. This makes the drawer feel instant while keeping its
        // existing premium shell and editor-controlled design untouched.
        qsa('cart-items-component[data-section-id]').forEach(function(component){
          var sid=component.getAttribute('data-section-id');
          if(sid && sections[sid] && typeof component.reconcileFromSectionHTML==='function'){
            try{ component.reconcileFromSectionHTML(sections[sid]); }catch(e){}
          }
        });

        btn.innerHTML='Added ✓';
        try{ document.dispatchEvent(new CustomEvent('cart-drawer:open')); document.dispatchEvent(new CustomEvent('cart:open')); window.dispatchEvent(new CustomEvent('cart-drawer:open')); }catch(e){}
        var drawer=document.querySelector('cart-drawer-component, cart-drawer, .cart-drawer, [data-cart-drawer], #cart-drawer');
        if(drawer){ try{ drawer.setAttribute('open',''); drawer.classList.add('is-open','active','animate'); if(typeof drawer.open==='function') drawer.open(); if(typeof drawer.showDialog==='function') drawer.showDialog(); }catch(e){} }
        if(!drawer){ var cartBtn=document.querySelector('[href$="/cart"], [aria-label*="cart" i], [aria-label*="panier" i], .header-actions__cart, cart-icon'); if(cartBtn){ try{ cartBtn.click(); }catch(e){} } }

        // Reconcile the authoritative item count and quantities in the background.
        // This request no longer blocks the drawer from opening.
        fetch('/cart.js',{cache:'no-store',credentials:'same-origin',priority:'low',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
          .then(function(r){return r.ok?r.json():null;})
          .then(function(cart){
            if(!cart) return;
            var eventDetail={resource:cart,data:{source:'ysn-bundle',itemCount:items.reduce(function(sum,it){return sum+(parseInt(it.quantity,10)||0);},0),sections:sections}};
            document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:eventDetail}));
          })
          .catch(function(){});

        setTimeout(function(){btn.innerHTML=old; btn.disabled=false;},700);
      })
      .catch(function(){btn.innerHTML='Check products'; setTimeout(function(){btn.innerHTML=old; btn.disabled=false;},1800);});
    }
    var scroll=e.target.closest('[data-nx-scroll]');
    if(scroll){
      var target=scroll.getAttribute('href') || scroll.getAttribute('data-target') || '#ProductInformation-';
      if(target && target.charAt(0) !== '#') return;
      e.preventDefault();
      var el=resolveYsnScrollTarget(target);
      if(el) scrollYsnTargetToStart(el);
    }
    var videoTrigger=e.target.closest('[data-nx-video-toggle], .nx-video-shell video');
    if(videoTrigger){
      var shell=videoTrigger.closest('.nx-video-shell');
      if(shell && shell.querySelector && shell.querySelector('video')){ e.preventDefault(); e.stopPropagation(); toggleVideo(shell); }
    }
    var photo=e.target.closest('[data-nx-photo]');
    if(photo){
      var modal=qs('.nx-modal');
      function nxBuildPhotoModal(){
        if(!modal){
          modal=document.createElement('div');
          modal.className='nx-modal';
          document.body.appendChild(modal);
        }
        if(!modal.querySelector('.nx-modal-frame') || !modal.querySelector('.nx-modal-nav')){
          modal.innerHTML='<div class="nx-modal-frame"><button class="nx-modal-close" aria-label="Close" type="button">×</button><button class="nx-modal-nav nx-modal-prev" aria-label="Previous photo" type="button">‹</button><img alt=""><button class="nx-modal-nav nx-modal-next" aria-label="Next photo" type="button">›</button></div>';
        }
        if(modal.dataset.nxPhotoReady==='1') return;
        modal.dataset.nxPhotoReady='1';
        function nxShowModalPhoto(dir){
          var list=(modal.dataset.photos||'').split('|').filter(Boolean);
          if(!list.length) return;
          var i=parseInt(modal.dataset.index||'0',10) || 0;
          if(dir) i = (i + dir + list.length) % list.length;
          modal.dataset.index=String(i);
          var img=qs('img',modal);
          if(img) img.src=list[i];
        }
        modal.addEventListener('click',function(ev){
          if(ev.target===modal || ev.target.classList.contains('nx-modal-close')) modal.classList.remove('is-open');
          if(ev.target.classList.contains('nx-modal-prev') || ev.target.classList.contains('nx-modal-next')){
            ev.preventDefault(); ev.stopPropagation();
            nxShowModalPhoto(ev.target.classList.contains('nx-modal-prev') ? -1 : 1);
          }
        });
        var sx=0;
        modal.addEventListener('touchstart',function(ev){ if(ev.touches && ev.touches[0]) sx=ev.touches[0].clientX; }, {passive:true});
        modal.addEventListener('touchend',function(ev){
          if(!sx || !ev.changedTouches || !ev.changedTouches[0]) return;
          var dx=ev.changedTouches[0].clientX-sx;
          if(Math.abs(dx)>45) nxShowModalPhoto(dx>0 ? -1 : 1);
          sx=0;
        }, {passive:true});
        document.addEventListener('keydown',function(ev){
          if(!modal.classList.contains('is-open')) return;
          if(ev.key==='Escape') modal.classList.remove('is-open');
          if(ev.key==='ArrowLeft') nxShowModalPhoto(-1);
          if(ev.key==='ArrowRight') nxShowModalPhoto(1);
        });
      }
      nxBuildPhotoModal();
      var sec=photo.closest('.nx-section') || document;
      var list=[];
      qsa('[data-nx-photo]', sec).forEach(function(el){
        var src=el.getAttribute('data-nx-photo');
        if(src && list.indexOf(src)===-1) list.push(src);
      });
      var current=photo.getAttribute('data-nx-photo');
      var index=Math.max(0, list.indexOf(current));
      modal.dataset.photos=list.join('|');
      modal.dataset.index=String(index);
      var img=qs('img',modal);
      if(img) img.src=current;
      var hasMultiple = list.length > 1;
      modal.classList.toggle('has-multiple', hasMultiple);
      qsa('.nx-modal-nav', modal).forEach(function(nav){
        nav.style.display = hasMultiple ? 'flex' : 'none';
        nav.style.opacity = hasMultiple ? '1' : '';
        nav.style.visibility = hasMultiple ? 'visible' : '';
        nav.style.pointerEvents = hasMultiple ? 'auto' : '';
      });
      modal.classList.add('is-open');
    }
    var lm=e.target.closest('[data-nx-load-more]');
    if(lm){var sec=lm.closest('.nx-section'); if(!sec)return; var hidden=qsa('.nx-review-card.is-hidden', sec); hidden.slice(0,6).forEach(function(el){el.classList.remove('is-hidden')}); if(qsa('.nx-review-card.is-hidden', sec).length===0) lm.remove();}
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Enter' || e.key===' '){ var card=e.target.closest && e.target.closest('[data-nx-offer-card]'); if(card){e.preventDefault(); card.click();}} });
  document.addEventListener('play', function(e){if(e.target && e.target.matches && e.target.matches('.nx-video-shell video')) setVideoState(e.target.closest('.nx-video-card'),true);}, true);
  document.addEventListener('pause', function(e){if(e.target && e.target.matches && e.target.matches('.nx-video-shell video')) setVideoState(e.target.closest('.nx-video-card'),false);}, true);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){init(document);}); else init(document);
  window.addEventListener('pageshow', function(){ init(document); qsa('[data-ysn17-link-bundle]', document).forEach(resetYsn17BundlePlanToDefault); setTimeout(function(){ init(document); qsa('[data-ysn17-link-bundle]', document).forEach(resetYsn17BundlePlanToDefault); }, 80); });
  document.addEventListener('shopify:section:load', function(e){init(e.target);});
  window.YSNFunnelInit=init;
})();

(function(){
  function initYsnActionVideos(root){
    (root || document).querySelectorAll('[data-ysn-video-toggle]').forEach(function(btn){
      if(btn.dataset.ysnReady) return;
      btn.dataset.ysnReady = '1';
      var wrap = btn.closest('.ysn-action-v60__video');
      var video = wrap && wrap.querySelector('video');
      if(!wrap || !video) return;
      wrap.classList.add('is-paused');
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        if(video.paused){
          video.play().then(function(){ wrap.classList.add('is-playing'); wrap.classList.remove('is-paused'); }).catch(function(){});
        } else {
          video.pause();
          wrap.classList.remove('is-playing');
          wrap.classList.add('is-paused');
        }
      });
      video.addEventListener('click', function(){
        if(video.paused){
          video.play().then(function(){ wrap.classList.add('is-playing'); wrap.classList.remove('is-paused'); }).catch(function(){});
        } else {
          video.pause();
          wrap.classList.remove('is-playing');
          wrap.classList.add('is-paused');
        }
      });
      video.addEventListener('pause', function(){ wrap.classList.remove('is-playing'); wrap.classList.add('is-paused'); });
      video.addEventListener('ended', function(){ wrap.classList.remove('is-playing'); wrap.classList.add('is-paused'); });
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ initYsnActionVideos(document); });
  document.addEventListener('shopify:section:load', function(e){ initYsnActionVideos(e.target); });
})();


/* V65: safe timeline tabs - no scroll lock, no forced scrollIntoView loop */
(function(){
  function initTimelineSafe(root){
    (root || document).querySelectorAll('.ysn-bio-timeline-v60').forEach(function(section){
      if(!section || section.__ysnTimelineV65) return;
      section.__ysnTimelineV65 = true;
      var tabs = Array.prototype.slice.call(section.querySelectorAll('.ysn-bio-timeline-v60__tabs a'));
      var items = Array.prototype.slice.call(section.querySelectorAll('.ysn-bio-timeline-v60__item[id]'));
      if(!tabs.length || !items.length) return;
      function getOffset(){
        var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        return header + 86;
      }
      function setActive(id){
        tabs.forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('href') === '#'+id); });
      }
      tabs.forEach(function(a){
        a.addEventListener('click', function(e){
          var href = a.getAttribute('href') || '';
          if(href.charAt(0) !== '#') return;
          var target = section.querySelector(href);
          if(!target) return;
          e.preventDefault();
          setActive(target.id);
          var y = target.getBoundingClientRect().top + window.pageYOffset - getOffset();
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        }, { passive:false });
      });
      var ticking = false;
      function onScroll(){
        if(ticking) return;
        ticking = true;
        window.requestAnimationFrame(function(){
          ticking = false;
          var line = section.querySelector('.ysn-bio-timeline-v60__line');
          if(!line) return;
          var trigger = getOffset() + 80;
          var current = items[0];
          items.forEach(function(item){
            if(item.getBoundingClientRect().top <= trigger) current = item;
          });
          if(current) setActive(current.id);
        });
      }
      window.addEventListener('scroll', onScroll, { passive:true });
      onScroll();
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){initTimelineSafe(document)}); else initTimelineSafe(document);
  document.addEventListener('shopify:section:load', function(e){initTimelineSafe(e.target)});
})();

/* YSN 06 revised video carousel: drag-safe swipe, prevents tap/play logic from blocking scroll */
(function(){
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function getPoint(ev){
    var t = ev.touches && ev.touches[0] ? ev.touches[0] : (ev.changedTouches && ev.changedTouches[0] ? ev.changedTouches[0] : ev);
    return {x: t.clientX || 0, y: t.clientY || 0};
  }
  function initYsn06StableSwipe(root){
    qsa('.ysn-video-section [data-ysn-scroll-row], .ysn-video-section .ysn-video-row', root).forEach(function(row){
      if(!row || row.__ysn06StableSwipe) return;
      row.__ysn06StableSwipe = true;
      var startX = 0, startY = 0, moved = false, down = false, mouseDown = false, startScroll = 0;
      var threshold = 8;

      function start(ev){
        var p = getPoint(ev);
        startX = p.x; startY = p.y; moved = false; down = true; startScroll = row.scrollLeft;
        row.classList.remove('is-ysn-dragging');
      }
      function move(ev){
        if(!down) return;
        var p = getPoint(ev);
        var dx = p.x - startX;
        var dy = p.y - startY;
        if(Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)){
          moved = true;
          row.classList.add('is-ysn-dragging');
        }
        if(mouseDown && moved){
          ev.preventDefault();
          row.scrollLeft = startScroll - dx;
        }
      }
      function end(){
        down = false; mouseDown = false;
        if(moved){
          row.setAttribute('data-ysn-dragged','true');
          setTimeout(function(){ row.classList.remove('is-ysn-dragging'); }, 60);
          setTimeout(function(){ row.removeAttribute('data-ysn-dragged'); }, 260);
        }else{
          row.classList.remove('is-ysn-dragging');
        }
      }

      row.addEventListener('touchstart', start, {passive:true});
      row.addEventListener('touchmove', move, {passive:true});
      row.addEventListener('touchend', end, {passive:true});
      row.addEventListener('touchcancel', end, {passive:true});
      row.addEventListener('mousedown', function(ev){ mouseDown = true; start(ev); }, {passive:true});
      window.addEventListener('mousemove', move, {passive:false});
      window.addEventListener('mouseup', end, {passive:true});

      row.addEventListener('click', function(ev){
        if(row.getAttribute('data-ysn-dragged') === 'true'){
          ev.preventDefault();
          ev.stopPropagation();
          if(ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        }
      }, true);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initYsn06StableSwipe(document); });
  else initYsn06StableSwipe(document);
  document.addEventListener('shopify:section:load', function(e){ initYsn06StableSwipe(e.target); });
})();
